<astrea-internal-banner
    title="{{ 'profile.my_profile' | translate }}"
></astrea-internal-banner>

<div class="astrea-profile content-height m-sm-5 m-2">
    <div class="container grid-25-75">

        <aside class="astrea-profile-aside mb-3">
            <mat-nav-list>
                <button (click)="handleOpenComponent('personal')" ngClass="{{ openComponent == 'personal' ? 'profile-active' : '' }}" mat-list-item>
                    <mat-icon class="mr-2" attr.aria-label="{{ 'profile.personal.personal' | translate }}">person</mat-icon>
                    {{ 'profile.personal.personal' | translate }}
                </button>
                <button *ngIf="!isUserShared" (click)="handleOpenComponent('invoicing')" ngClass="{{ openComponent == 'invoicing' ? 'profile-active' : '' }}" mat-list-item>
                    <mat-icon class="mr-2" attr.aria-label="{{ 'profile.invoicing.invoicing' | translate }}">receipt</mat-icon>
                    {{ 'profile.invoicing.invoicing' | translate }}
                </button>
                <button (click)="handleOpenComponent('config')" ngClass="{{ openComponent == 'config' ? 'profile-active' : '' }}" mat-list-item>
                    <mat-icon class="mr-2" attr.aria-label="{{ 'profile.config.config' | translate }}">settings</mat-icon>
                    {{ 'profile.config.config' | translate }}
                </button>
                <button *ngIf="!isUserShared" (click)="handleOpenComponent('security')" ngClass="{{ openComponent == 'security' ? 'profile-active' : '' }}" mat-list-item>
                    <mat-icon class="mr-2" attr.aria-label="{{ 'profile.security.security' | translate }}">verified_user</mat-icon>
                    {{ 'profile.security.security' | translate }}
                </button>
            </mat-nav-list>
        </aside>

        <div class="astrea-box overflow-hidden">
            <div *ngIf="!loadingPage; else astreaLoading">
                <astrea-profile-personal
                    *ngIf="openComponent == 'personal'"
                    [setUser]="user"
                    [isUserShared]="isUserShared"
                ></astrea-profile-personal>
                <astrea-profile-invoicing
                    *ngIf="openComponent == 'invoicing' && !isUserShared"
                    [setUser]="user"
                ></astrea-profile-invoicing>
                <astrea-profile-config
                    *ngIf="openComponent == 'config'"
                    [setUser]="user"
                    [isUserShared]="isUserShared"
                ></astrea-profile-config>
                <astrea-profile-security
                    *ngIf="openComponent == 'security' && !isUserShared"
                    [setUser]="user"
                ></astrea-profile-security>
            </div>
            <ng-template #astreaLoading>
                <astrea-loading
                    [text]="'profile.loading' | translate"
                ></astrea-loading>
            </ng-template>
        </div>

    </div>
</div>
